import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

// サーバーURL
const baseUrl = dev; //エンドポイント

const config = {
  timeout: 30000,
  method: null, // POSTメソッドを設定
  url: '',
  data: null,
  withCredentials: true,
};

export default {
  getBoardViewInfo: (
    tableId,
    authInfo
  ) => {
    if(tableId != "undefined" && tableId != null && tableId != undefined){
    config.url = baseUrl + "/api/boardView/get";
    config.method = "POST";

    config.data = {
      tableId,
      authInfo
    }

    return axios.request(config)
      .then(res => { return res })
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー発生時
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.msg; // 認証エラー発生時
            router.push('/login'); // ログインページにリダイレクト
          } else {
            ErrMsg = err.response.data.msg; // その他のエラーメッセージ
          }
        } else {
          ErrMsg = err.message; // その他のエラーメッセージ
        }
        return ErrMsg; // エラーメッセージを返す
      })
    } else {
      console.log("tableIdがNULL又はUndefinedです tableId: ", tableId)
    }
  },

  editBoardTitle: (tableId, bordTitle) => {
    // ローカルストレージからデータを取得
    const authUserId = localStorage.getItem('authUserId');
    const sessionKey = localStorage.getItem('sessionKey');
    const staffName = localStorage.getItem('staffName');

    // 必要なデータが存在しない場合はエラーを返す
    if (!authUserId || !sessionKey) {
      console.log('authInfo または sessionKey が見つかりません');
    }
    
    const authInfo =
      { authUserId: authUserId, sessionKey: sessionKey };
    const config = {
      url: baseUrl + "/api/boardView/edit",
      method: "POST",
      data: {
        tableId: tableId,
        tableName: bordTitle,
        authInfo: authInfo, // JSON 配列をリクエストデータに含める
        staffName: staffName,
      },
    };
    return axios
      .request(config)
      .then(res => res) // 成功時にレスポンスを返す
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.msg; // 認証エラー
            router.push('/login'); // ログインページにリダイレクト
          } else {
            ErrMsg = err.response.data.msg; // その他のエラー
          }
        } else {
          ErrMsg = err.message; // その他のエラー
        }
        return ErrMsg; // エラーメッセージを返す
      });
  }
}